import React from 'react';
export const DocIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon" style={{ fill: 'rgb(240, 171, 0)' }}>
      <svg {...props} id="icon-documents" viewBox="0 0 13 15">
        <title>Documents</title>
        <path
          d="M13.007,6.102 C13.007,5.142 12.551,4.535 11.895,3.887 C11.895,3.887 8.922,0.957 8.922,0.957 C8.489,0.530 8.072,0.190 7.559,0.007 C7.559,0.007 0.343,0.007 0.343,0.007 C0.179,0.007 -0.000,0.136 -0.000,0.296 C-0.000,0.296 -0.000,14.712 -0.000,14.712 C-0.000,14.871 0.179,15.001 0.343,15.001 C0.343,15.001 12.669,15.001 12.669,15.001 C12.834,15.001 13.010,14.871 13.010,14.712 C13.010,14.712 13.010,6.105 13.010,6.105 C13.010,6.105 13.007,6.102 13.007,6.102 ZM7.872,5.069 C7.872,5.069 7.872,0.889 7.872,0.889 C7.872,0.889 12.073,5.069 12.073,5.069 C12.073,5.069 7.872,5.069 7.872,5.069 Z"
          fillRule="evenodd"
        ></path>
      </svg>
    </svg>
  );
};
